import { z } from "zod";

/// URL state for Reviews > Insights: the page-wide focus review. It drives
/// the KPI strip, the rating distribution, and the manager calibration
/// table. The department comparison and the average trend stay cross-cycle
/// on purpose, comparing reviews is their whole job. Absent = the latest
/// released review.
export const reviewInsightsSearchSchema = z
  .object({
    cycle: z.string().optional().catch(undefined),
  })
  .strict();
export type ReviewInsightsSearch = z.infer<typeof reviewInsightsSearchSchema>;
